module.exports = __webpack_public_path__ + "img/myArticle.3174f256.png";